import { FC } from 'react';
import { useTitle } from 'react-use';
import { useTheme } from 'styled-components';

import { ButtonLink } from '@savgroup-front-common/core/atoms/button';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { buildPageTitle } from '@savgroup-front-common/core/helpers';
import { BaseLoader } from '@savgroup-front-common/core/molecules/BaseLoader';
import { EmptyInboxIcon } from '@savgroup-front-common/core/protons/icons';
import { MyAccountIcon } from '@savgroup-front-common/core/protons/IconsNewDesign/MyAccount.icon';
import { ICONS_TYPE } from '@savgroup-front-common/types';
import { PROFESSIONAL_STEP_CONFIG } from '@/view/app/NewLayout/ProfessionalRoutes.config';
import { buildProfessionalRoute } from '@/view/app/NewLayout/ProfessionalRoutes.helpers';

import { $HomeProductsListWrapper } from '../HomePageProfessional.styles';

import useListOwnerProductsQuery from './ClaimsToFinalizePage.hooks';
import messages from './messages';

const ClaimsToFinalizePage: FC = () => {
  const { isLoading } = useListOwnerProductsQuery();
  const theme = useTheme();

  useTitle(buildPageTitle([messages.claimsToFinalizePageTitle]));

  if (isLoading) {
    return <BaseLoader />;
  }

  return (
    <$HomeProductsListWrapper>
      <EmptyInboxIcon
        color={theme.colors.primary}
        secondColor={theme.colors.secondary}
      />
      <SafeFormattedMessageWithoutSpread message={messages.createFile} />
      <ButtonLink
        primary
        icon={<MyAccountIcon icon={ICONS_TYPE.CONSUMABLE_ICON} />}
        href={buildProfessionalRoute({
          route: PROFESSIONAL_STEP_CONFIG.PROFESSIONAL_ISSUES_REASONS_PAGE,
        })}
        small
      >
        <SafeFormattedMessageWithoutSpread
          message={messages.createFileButton}
        />
      </ButtonLink>
    </$HomeProductsListWrapper>
  );
};

ClaimsToFinalizePage.displayName = 'ClaimsToFinalizePage';

export default ClaimsToFinalizePage;
